import type { Variable } from "@/domains/templates/types";

function storedVariableName(variable: Variable): string {
  return variable.variable_name_frontend ?? variable.variable_name;
}

export type ResolvedVariableReference = {
  name: string;
  directSource?: Variable;
};

export function createVariableReferenceResolver(sourceVariables: Variable[]) {
  const variablesById = new Map(
    sourceVariables.map((variable) => [variable.variable_id, variable]),
  );

  return (variable: Variable): ResolvedVariableReference => {
    const directSource = variable.source_variable_id
      ? variablesById.get(variable.source_variable_id)
      : undefined;
    const visited = new Set<string>();
    let current = variable;

    while (current.source_variable_id) {
      visited.add(current.variable_id);
      const source = variablesById.get(current.source_variable_id);
      if (!source || visited.has(source.variable_id)) break;
      current = source;
    }

    return { name: storedVariableName(current), directSource };
  };
}

export function createVariableNameResolver(sourceVariables: Variable[]) {
  const resolveReference = createVariableReferenceResolver(sourceVariables);
  return (variable: Variable): string => resolveReference(variable).name;
}
